import { c as _c } from "react/compiler-runtime";
import { Slot, Slottable } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { Loader2 } from "lucide-react";
import * as React from "react";
import { cn } from "#lib/utils.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const buttonVariants = cva("inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", {
  variants: {
    variant: {
      default: "bg-primary text-primary-foreground hover:bg-primary/90",
      destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
      outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
      secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
      ghost: "hover:bg-accent hover:text-accent-foreground",
      link: "text-primary underline-offset-4 hover:underline"
    },
    size: {
      default: "h-10 px-4 py-2",
      sm: "h-9 rounded-md px-3",
      lg: "h-11 rounded-md px-8",
      icon: "h-10 w-10"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
});
const LoadingButton = /*#__PURE__*/React.forwardRef((t0, ref) => {
  const $ = _c(25);
  let children;
  let className;
  let disabled;
  let props;
  let size;
  let t1;
  let t2;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      loading: t1,
      children,
      disabled,
      variant,
      size,
      asChild: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = disabled;
    $[4] = props;
    $[5] = size;
    $[6] = t1;
    $[7] = t2;
    $[8] = variant;
  } else {
    children = $[1];
    className = $[2];
    disabled = $[3];
    props = $[4];
    size = $[5];
    t1 = $[6];
    t2 = $[7];
    variant = $[8];
  }
  const loading = t1 === undefined ? false : t1;
  const asChild = t2 === undefined ? false : t2;
  const Comp = asChild ? Slot : "button";
  let t3;
  if ($[9] !== className || $[10] !== size || $[11] !== variant) {
    t3 = cn(buttonVariants({
      variant,
      size,
      className
    }));
    $[9] = className;
    $[10] = size;
    $[11] = variant;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const t4 = loading || disabled;
  let t5;
  if ($[13] !== loading) {
    t5 = loading && /*#__PURE__*/_jsx(Loader2, {
      className: "mr-2 h-5 w-5 animate-spin"
    });
    $[13] = loading;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== children) {
    t6 = /*#__PURE__*/_jsx(Slottable, {
      children: children
    });
    $[15] = children;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== Comp || $[18] !== props || $[19] !== ref || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6) {
    t7 = /*#__PURE__*/_jsxs(Comp, {
      className: t3,
      ref: ref,
      disabled: t4,
      ...props,
      children: [t5, t6]
    });
    $[17] = Comp;
    $[18] = props;
    $[19] = ref;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
});
LoadingButton.displayName = "LoadingButton";
export { buttonVariants, LoadingButton };